module.exports = __webpack_public_path__ + "static/media/blood3.b23e99ff.svg";